import React from 'react';
import PropTypes from 'prop-types';
import _orderBy from 'lodash/orderBy';

import { FontSizes, FontWeights } from 'constants/Clementine';

class Table extends React.Component {
  static propTypes = {
    columns: PropTypes.array,
    id: PropTypes.string,
    data: PropTypes.array,
    defaultSortDirection: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      sort_by_column: props.columns.find(c => c.default) || {},
      sort_direction: props.defaultSortDirection || 'asc'
    };
  }

  _handleColumnSort = column => {
    if (column.is_sortable) {
      this.setState({
        sort_by_column: column,
        sort_direction: this.state.sort_direction === 'asc' ? 'desc' : 'asc'
      });
    }
  };

  render() {
    const { columns, id, data } = this.props;
    const { sort_by_column, sort_direction } = this.state;
    const sorted_data = _orderBy(data || [], sort_by_column.sort_by || sort_by_column.render || sort_by_column.id, sort_direction);
    return (
      <table style={styles.table}>
        <thead>
          <tr>
            {columns?.map(column => (
              <th
                key={column.id}
                style={{ ...styles.tableRow, ...styles.tableHeader }}
                onClick={this._handleColumnSort.bind(null, column)}
              >
                {column.label}
                {column.is_sortable && sort_by_column.id === column.id ? (
                  <i className={`mdi ${sort_direction === 'asc' ? 'mdi-chevron-up' : 'mdi-chevron-down'}`} style={styles.arrowStyle} />
                ) : null}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sorted_data?.map((item, index) => (
            <tr key={`${id}${index}`}>
              {columns?.map(column => (
                <td
                  key={column.id}
                  style={{ ...styles.tableRow, ...styles.tableCell }}
                >
                  {column.render ? column.render(item) : item[column.id]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
    backgroundColor: "#fff"
  },
  tableRow: {
    width: "200px",
    padding: "10px",
    textAlign: "center",
  },
  tableHeader: {
    color: "#FFF",
    backgroundColor: "#2F3B44",
    border: "1px solid #fff",
    cursor: 'pointer',
    textTransform: 'uppercase',
    fontWeight: FontWeights.MEDIUM,
    fontSize: FontSizes.SMALL,
    lineHeight: '1.2em',
  },
  arrowStyle: {
    color: "#FFF",
    marginLeft: 5,
    fontSize: 14
  },
  tableCell: {
    border: "1px solid #000",
    fontSize: FontSizes.REGULAR,
    lineHeight: '1.4em',
  }
};

export default Table;
